<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.8 2.5h.4c.865 0 1.423.001 1.848.036.408.033.559.09.633.127a1.5 1.5 0 01.656.656c.037.074.094.225.127.633.023.277.031.61.034 1.048-1.481.001-2.258.02-2.86.327a3 3 0 00-1.311 1.311C5.02 7.24 5.001 8.017 5 9.498a14.624 14.624 0 01-1.048-.034c-.408-.033-.559-.09-.633-.127a1.5 1.5 0 01-.656-.656c-.037-.074-.094-.225-.127-.633C2.5 7.623 2.5 7.065 2.5 6.2v-.4c0-.865.001-1.423.036-1.848.033-.408.09-.559.127-.633a1.5 1.5 0 01.656-.656c.074-.037.225-.094.633-.127C4.377 2.5 4.935 2.5 5.8 2.5zm-.798 8.498c-1.166-.008-1.833-.054-2.364-.325a3 3 0 01-1.311-1.311C1 8.72 1 7.88 1 6.2v-.4c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C3.28 1 4.12 1 5.8 1h.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311c.27.531.317 1.198.325 2.364 1.166.008 1.833.054 2.364.325a3 3 0 011.311 1.311C15 7.28 15 8.12 15 9.8v.4c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C12.72 15 11.88 15 10.2 15h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311c-.27-.531-.317-1.198-.325-2.364z"
    fill="currentColor"
  />
</svg>
